export default __webpack_public_path__ + "static/media/Plus.9e10baa2.svg";